import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--percent" icon='percent'>{ children ? children : '0' }</Button>
}